import { render } from "./goodsOrder.vue?vue&type=template&id=29f513be&scoped=true"
import script from "./goodsOrder.vue?vue&type=script&lang=js"
export * from "./goodsOrder.vue?vue&type=script&lang=js"

import "./goodsOrder.vue?vue&type=style&index=0&id=29f513be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f513be"]])

export default __exports__